import React, { useEffect, useRef } from 'react';
import { TerminalIcon } from 'lucide-react';
import { motion } from 'framer-motion';
type TerminalProps = {
  messages: string[];
};
export const Terminal = ({
  messages
}: TerminalProps) => {
  const terminalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [messages]);
  return <motion.div className="border border-green-500 bg-black p-2 font-mono text-sm rounded-lg animate-glow" initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3
  }} data-id="element-83">
      <div className="flex items-center mb-1 text-green-400 border-b border-green-500/30 pb-1" data-id="element-84">
        <TerminalIcon size={14} className="mr-1" data-id="element-85" />
        <span data-id="element-86">Terminal</span>
      </div>
      <div ref={terminalRef} className="h-40 overflow-y-auto text-green-400 text-xs pr-1" data-id="element-87">
        {messages.map((message, index) => <motion.div key={index} className="mb-1" initial={{
        opacity: 0,
        x: -5
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.2
      }} data-id="element-88">
            <span className="text-green-500" data-id="element-89">{'>'}</span> {message}
            {index === messages.length - 1 && <span className="animate-pulse" data-id="element-90">_</span>}
          </motion.div>)}
      </div>
    </motion.div>;
};